import {Component, OnInit, ViewChild} from '@angular/core';
import {timer} from 'rxjs';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {OrderCancellationService} from '../services/order-cancellation.service';
import {OrderRequestCancellationCodeResultModel} from '../../models/order-request-cancellation-code-result-model';
import {PHONE_MASK} from '../../helpers/format-helpers';
import {TranslateService} from '@ngx-translate/core';
import {OrderRequestCancellationCodeModel} from '../../models/order-request-cancellation-code-model';
import {MatHorizontalStepper} from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
  selector: 'app-order-cancellation',
  templateUrl: './order-cancellation.component.html',
  styleUrls: ['./order-cancellation.component.scss'],
})
export class OrderCancellationComponent implements OnInit {

  phoneMask = PHONE_MASK;

  ticks = 0;
  timer;
  cancelForm: FormGroup;
  tokenForm: FormGroup;
  smsForm: FormGroup;
  reasonForm: FormGroup;
  changePhoneForm: FormGroup;

  changeEmailForm: FormGroup;

  maskedEmail = null;



  newEmailVisible = false;

  showErrorChangeMail: boolean;
  errorMessageChangeMail: string;


  maxDob = this.getMaxDateOfBirth();
  minDob = this.getMinDateOfBirth();


  phone: string;
  newPhoneToSet: string;
  dob: Date;
  smsSent: boolean;
  orderDetails: OrderRequestCancellationCodeResultModel;
  changePhoneVisible = false;
  isSendingCode = false;

  showUserCancellationReasonCustom = false;

  @ViewChild(MatHorizontalStepper, {static: false}) stepper: MatHorizontalStepper;

  constructor(
    private formBuilder: FormBuilder,
    private orderCancellationService: OrderCancellationService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    ) { }




  onUserCancellationReasonChanged(){
    if( this.reasonForm.value != null && this.reasonForm.value.userCancellationReason == 6 ){
      this.showUserCancellationReasonCustom = true;
    }else{
      this.showUserCancellationReasonCustom = false;
    }
    this.reasonForm.controls['reason'].patchValue('');
  }

  requiredIfReasonValueIs6(formControl: AbstractControl) {
    if (!formControl.parent) {
      return null;
    }

    if (formControl.parent.get('userCancellationReason').value === 6) {
      if ( !formControl.value ) {
        return { required: true };
      }

    if ( formControl.value != null && formControl.value.length > 250 ) {
return { too_long: true };
}

    }
    return null;
  }

  ngOnInit() {
    this.tokenForm = this.formBuilder.group({ token: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]] });
    this.smsForm = this.formBuilder.group({ code:  ['', [Validators.required]]});
    this.reasonForm = this.formBuilder.group({
      code: [''],
      userCancellationReason: ['', [Validators.required]],
      //reason:  ["", Validators.maxLength(250), this.requireIfValue0() ]});
      reason: new FormControl('', [
        this.requiredIfReasonValueIs6
      ])
    });

    this.cancelForm = this.formBuilder.group({
      token: this.tokenForm,
      sms:  this.smsForm,
      reason: this.reasonForm,
    });
  }

  changePhoneNr(){
    this.changePhoneVisible = !this.changePhoneVisible;
    this.changePhoneForm = this.formBuilder.group({
      dob: null,
      phone:  ''
    });
  }

  onChangePhoneSubmit(){
    if( !this.changePhoneForm.valid ) {
return;
}

    this.orderCancellationService.changeMobilephoneNumber(this.tokenForm.value.token, this.changePhoneForm.value).subscribe(result => {
      console.log(result);
      this.phone = this.changePhoneForm.value.phone;

      this.translate.get(['ORDER_CANCELLATION.PHONE.FORM_CHANGE.SUCCESS']).subscribe((res: string[]) => {

        let msg = res['ORDER_CANCELLATION.PHONE.FORM_CHANGE.SUCCESS'];
        msg = msg.replace('{{value}}',this.phone);
        this.changePhoneVisible = false;

        this.snackBar.open(msg, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        });

      });
      this.sendPhoneCode();
    },
    error => {

      this.translate.get(['ORDER_CANCELLATION.PHONE.FORM_CHANGE.NOT_FOUND', 'ORDER_CANCELLATION.PHONE.FORM_CHANGE.SAME_NUMBER', 'ORDER_CANCELLATION.PHONE.FORM_CHANGE.ERROR']).subscribe((res: string[]) => {

        if (error.status == 404) {
          const msg = res['ORDER_CANCELLATION.PHONE.FORM_CHANGE.NOT_FOUND'];
          this.snackBar.open(msg, null, {
            duration: 5000,
            panelClass: ['app-mat-snack-bar']
          });
        } else if(error.status == 500 && error.error == 'same number') {
          const msg = res['ORDER_CANCELLATION.PHONE.FORM_CHANGE.SAME_NUMBER'];
          this.snackBar.open(msg, null, {
            duration: 5000,
            panelClass: ['app-mat-snack-bar']
          });
        } else{
          const msg = res['ORDER_CANCELLATION.PHONE.FORM_CHANGE.ERROR'];
          this.snackBar.open(msg, null, {
            duration: 5000,
            panelClass: ['app-mat-snack-bar']
          });
        }

      });


      console.log(error);
    });

  }






  sendToken(value: any) {
    this.orderCancellationService.requestCancellation(value.token).subscribe(result => {
      this.phone = result.maskedPhone;
      this.maskedEmail = result.maskedEmail;
      this.stepper.next();
      // this.sendPhoneCode();
    });
  }

  sendPhoneCode() {
    this.smsSent = true;
    this.orderCancellationService.requestCancellationVerificationCode(this.tokenForm.value.token).subscribe(result => {
      this.timer = timer(30, 1000);
      const subscription = this.timer.subscribe(t => {
        this.ticks = 30 - t;
        if (this.ticks == 0) {
          subscription.unsubscribe();
        }
      });
    });
  }

  verifyPhoneCode(value: any) {
    this.orderCancellationService.confirmCancellationVerificationCode(this.tokenForm.value.token, value).subscribe(result => {
      this.orderDetails = result;
      this.stepper.next();
    });
  }



  getMaxDateOfBirth() {
    // This is used to prevent persons under 18 years from creating orders
    // There is an additional control in the API, consider it when changing the minimal person age.
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 18);
    maxDate.setHours(0,0,0,0);
    return maxDate;
  }

  getMinDateOfBirth() {
    // MS
    // This is used to prevent persons from entering birth dates that are over 100 years ago
    // There is an additional control in the API, consider it when changing the maximum person age.
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 100);
    minDate.setHours(0,0,0,0);
    return minDate;
  }

  getTick() {
    return this.ticks != 0 ? ' (' + this.ticks + ')' : '';
  }

  doBackFromChangeEmail() {
    this.newEmailVisible = false;
    this.changeEmailForm = this.formBuilder.group({
      email: null,
      dob:  ''
    });
  }

  showChangeEmailForm(){
    this.newEmailVisible = true;

    this.changeEmailForm = this.formBuilder.group({
      email: null,
      dob:  ''
    });

  }


  disableChangeEmailControls = false;

  submitCancellationDetails(value: any) {

    value.code = this.smsForm.value.code;

    this.orderCancellationService.submitCancellationDetails(this.tokenForm.value.token, value).subscribe(result => {

      this.stepper.next();
    });
  }


  doRequestChangeEmailAndSubmitCancellationDetails(value: any) {
    this.showErrorChangeMail = false;
    this.disableChangeEmailControls = true;

    const request = new OrderRequestCancellationCodeModel();

    request.changeRequested = true;
    request.emailToConfirm = this.changeEmailForm.value.email;
    request.reason = value.reason;
    request.userCancellationReason = value.userCancellationReason;
    request.dob = this.changeEmailForm.value.dob;
    request.code = this.smsForm.value.code;


    this.orderCancellationService.submitCancellationDetails(this.tokenForm.value.token, request).subscribe(result => {
      this.maskedEmail = result;
      this.stepper.next();
    },
        error => {
      this.disableChangeEmailControls = false;
    }
    );


    /*
    this.orderCancellationService.sendEmailConfirmLink(this.tokenForm.value.token, this.newEmailToSet, true, this.dobForEmailChange)
      .subscribe(result => {

        if ( result.ok == true ) {
          this.showErrorChangeMail = false;
          this.confirmEmailVisible = false;
          this.newEmailVisible = false;
          this.mandateNumberEnabled = false;

          this.emailInstructionsWhereSentTo = this.emailToConfirm;
          this.emailSentInstructionsVisible = true;

          this.emailInstructionsWhereSentTo = this.newEmailToSet;
          this.emailSentInstructionsVisible = true;

        } else {
          this.showErrorChangeMail = true;
          this.errorMessageChangeMail = result.message;
        }

        this.disableChangeEmailControls = false;

      }, error => this.disableChangeEmailControls = false);

     */
  }

}
